import * as i0 from '@angular/core';
import { Injectable, Pipe, Component, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { Subject } from 'rxjs';
import { environment } from 'environment-configurations';
import * as i1$1 from 'primeng/dynamicdialog';
import * as i3 from '@angular/common';
import * as i4 from 'primeng/table';
import * as i5 from 'primeng/api';
import * as i6 from 'ngx-extended-pdf-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PrimengLibraryModule } from 'primeng-library';

class LibViewPayslipService {
    constructor(http) {
        this.http = http;
    }
    getPayslipDownloadDetails(payload) {
        return this.http.post(`/vd/formBuilder/employee/payroll/payslip/details`, payload).pipe(map((response) => response));
    }
}
LibViewPayslipService.ɵfac = function LibViewPayslipService_Factory(t) { return new (t || LibViewPayslipService)(i0.ɵɵinject(i1.HttpClient)); };
LibViewPayslipService.ɵprov = i0.ɵɵdefineInjectable({ token: LibViewPayslipService, factory: LibViewPayslipService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibViewPayslipService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class NumberToWordsPipe {
    transform(value) {
        if (value && isInteger(value))
            return numToWords(value);
        return value;
    }
}
NumberToWordsPipe.ɵfac = function NumberToWordsPipe_Factory(t) { return new (t || NumberToWordsPipe)(); };
NumberToWordsPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "numberToWords", type: NumberToWordsPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NumberToWordsPipe, [{
        type: Pipe,
        args: [{
                name: "numberToWords",
            }]
    }], null, null); })();
const isInteger = function (x) {
    return x % 1 === 0;
};
const arr = (x) => Array.from(x);
const num = (x) => Number(x) || 0;
const str = (x) => String(x);
const isEmpty = (xs) => xs.length === 0;
const take = (n) => (xs) => xs.slice(0, n);
const drop = (n) => (xs) => xs.slice(n);
const reverse = (xs) => xs.slice(0).reverse();
const comp = (f) => (g) => (x) => f(g(x));
const not = (x) => !x;
const chunk = (n) => (xs) => isEmpty(xs) ? [] : [take(n)(xs), ...chunk(n)(drop(n)(xs))];
// numToWords :: (Number a, String a) => a -> String
let numToWords = (n) => {
    let a = [
        "",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "ten",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen",
    ];
    let b = [
        "",
        "",
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety",
    ];
    let g = [
        "",
        "thousand",
        "million",
        "billion",
        "trillion",
        "quadrillion",
        "quintillion",
        "sextillion",
        "septillion",
        "octillion",
        "nonillion",
    ];
    // this part is really nasty still
    // it might edit this again later to show how Monoids could fix this up
    let makeGroup = ([ones, tens, huns]) => {
        return [
            num(huns) === 0 ? "" : a[huns] + " hundred ",
            num(ones) === 0 ? b[tens] : (b[tens] && b[tens] + "-") || "",
            a[tens + ones] || a[ones],
        ].join("");
    };
    // "thousands" constructor; no real good names for this, i guess
    let thousand = (group, i) => (group === "" ? group : `${group} ${g[i]}`);
    // execute !
    if (typeof n === "number")
        return numToWords(String(n));
    if (n === "0")
        return "zero";
    return comp(chunk(3))(reverse)(arr(n))
        .map(makeGroup)
        .map(thousand)
        .filter(comp(not)(isEmpty))
        .reverse()
        .join(" ");
};

function LibViewPayslipComponent_div_0_ng_template_78_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th", 20);
    i0.ɵɵtext(2, "EARNINGS");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th", 20);
    i0.ɵɵtext(4, "DEDUCTIONS");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "tr");
    i0.ɵɵelementStart(6, "th");
    i0.ɵɵtext(7, "Particulars ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9, "Rs. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th");
    i0.ɵɵtext(11, "Particulars ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th");
    i0.ɵɵtext(13, "Rs. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibViewPayslipComponent_div_0_ng_template_79_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, "GROSS PAY");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6, "TAX");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 21);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "tr");
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵtext(11, "EARNINGS");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td");
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "td");
    i0.ɵɵtext(15, "DEDUCTIONS");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td", 21);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const breakup_r5 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate((breakup_r5 == null ? null : breakup_r5.totalEmployerContribution) ? breakup_r5 == null ? null : breakup_r5.totalEmployerContribution : "NA");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", (breakup_r5 == null ? null : breakup_r5.totalEmployerContribution) ? breakup_r5 == null ? null : breakup_r5.totalEmployerContribution : "NA", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((breakup_r5 == null ? null : breakup_r5.totalEmployerContribution) ? breakup_r5 == null ? null : breakup_r5.totalEmployerContribution : "NA");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", (breakup_r5 == null ? null : breakup_r5.totalEmployerContribution) ? breakup_r5 == null ? null : breakup_r5.totalEmployerContribution : "NA", " ");
} }
function LibViewPayslipComponent_div_0_ng_template_80_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "h6");
    i0.ɵɵtext(3, "Total Earnings");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "h6");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵelementStart(8, "h6");
    i0.ɵɵtext(9, "Total Deductions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵelementStart(11, "h6");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "tr");
    i0.ɵɵelementStart(14, "td", 22);
    i0.ɵɵtext(15, " NET SALARY In Amount - ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td", 23);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "tr");
    i0.ɵɵelementStart(19, "td", 24);
    i0.ɵɵtext(20, " NET SALARY In Figure - ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "td", 25);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "numberToWords");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate((ctx_r4.getBreakupDetails[0] == null ? null : ctx_r4.getBreakupDetails[0].grandTotal) ? ctx_r4.getBreakupDetails[0] == null ? null : ctx_r4.getBreakupDetails[0].grandTotal : "NA");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate((ctx_r4.getBreakupDetails[0] == null ? null : ctx_r4.getBreakupDetails[0].totalDeductions) ? ctx_r4.getBreakupDetails[0] == null ? null : ctx_r4.getBreakupDetails[0].totalDeductions : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r4.getBreakupDetails[0] == null ? null : ctx_r4.getBreakupDetails[0].grandTotal) ? ctx_r4.getBreakupDetails[0] == null ? null : ctx_r4.getBreakupDetails[0].grandTotal : "NA", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 4, ctx_r4.getBreakupDetails[0] == null ? null : ctx_r4.getBreakupDetails[0].grandTotal), " ");
} }
function LibViewPayslipComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵelement(4, "img", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵelementStart(6, "h3", 7);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 8);
    i0.ɵɵelementStart(10, "div", 9);
    i0.ɵɵelementStart(11, "h5", 10);
    i0.ɵɵtext(12, "SALARY SLIP");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 11);
    i0.ɵɵelementStart(14, "ul");
    i0.ɵɵelementStart(15, "li");
    i0.ɵɵelementStart(16, "p");
    i0.ɵɵtext(17, "STAFF CODE :");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "span");
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "li");
    i0.ɵɵelementStart(21, "p");
    i0.ɵɵtext(22, "NAME : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "span");
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "li");
    i0.ɵɵelementStart(26, "p");
    i0.ɵɵtext(27, "DESIGNATION :");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "span");
    i0.ɵɵtext(29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "li");
    i0.ɵɵelementStart(31, "p");
    i0.ɵɵtext(32, "DEBT : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "span");
    i0.ɵɵtext(34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "li");
    i0.ɵɵelementStart(36, "p");
    i0.ɵɵtext(37, "LOAN NO : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "span");
    i0.ɵɵtext(39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "li");
    i0.ɵɵelementStart(41, "p");
    i0.ɵɵtext(42, "MONTH : ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "span");
    i0.ɵɵtext(44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(45, "div", 11);
    i0.ɵɵelementStart(46, "ul");
    i0.ɵɵelementStart(47, "li");
    i0.ɵɵelementStart(48, "p");
    i0.ɵɵtext(49, "PRESENT DAY :");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(50, "span");
    i0.ɵɵtext(51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(52, "li");
    i0.ɵɵelementStart(53, "p");
    i0.ɵɵtext(54, "ABSENT DAY :");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(55, "span");
    i0.ɵɵtext(56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(57, "li");
    i0.ɵɵelementStart(58, "p");
    i0.ɵɵtext(59, "BANK NAME :");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(60, "span");
    i0.ɵɵtext(61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(62, "li");
    i0.ɵɵelementStart(63, "p");
    i0.ɵɵtext(64, "BRANCH :");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(65, "span");
    i0.ɵɵtext(66);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(67, "li");
    i0.ɵɵelementStart(68, "p");
    i0.ɵɵtext(69, "A/C NO :");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(70, "span");
    i0.ɵɵtext(71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(72, "li");
    i0.ɵɵelementStart(73, "p");
    i0.ɵɵtext(74, "A/C TYPE :");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(75, "span");
    i0.ɵɵtext(76);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(77, "p-table", 12);
    i0.ɵɵtemplate(78, LibViewPayslipComponent_div_0_ng_template_78_Template, 14, 0, "ng-template", 13);
    i0.ɵɵtemplate(79, LibViewPayslipComponent_div_0_ng_template_79_Template, 18, 4, "ng-template", 14);
    i0.ɵɵtemplate(80, LibViewPayslipComponent_div_0_ng_template_80_Template, 24, 6, "ng-template", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(81, "div", 16);
    i0.ɵɵelementStart(82, "div", 17);
    i0.ɵɵelementStart(83, "p");
    i0.ɵɵtext(84);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(85, "div", 18);
    i0.ɵɵelementStart(86, "p");
    i0.ɵɵtext(87, "* This is Computer generated Slip does not required signature.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(88, "p");
    i0.ɵɵtext(89, "* Contact us for any details.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(90, "p");
    i0.ɵɵtext(91, "* Is any query kindly email us.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(92, "div", 19);
    i0.ɵɵelementStart(93, "p");
    i0.ɵɵtext(94);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate((ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].companyName) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].companyName : "NA");
    i0.ɵɵadvance(12);
    i0.ɵɵtextInterpolate((ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].employeeId) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].employeeId : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].employeeName) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].employeeName : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].designation) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].designation : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].department) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].department : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].employeeId) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].employeeId : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].monthYear) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].monthYear : "NA");
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate((ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].presentDays) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].presentDays : 0);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].absentDays) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].absentDays : 0);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].bankName) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].bankName : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].branchName) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].branchName : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].accountNumber) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].accountNumber : "NA");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].accountType) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].accountType : "NA");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r0.getBreakupDetails)("responsive", true);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1("Prepared by... ", (ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].preparedBy) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].preparedBy : "NA", "");
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate((ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].companyUrl) ? ctx_r0.getBreakupDetails[0] == null ? null : ctx_r0.getBreakupDetails[0].companyUrl : "NA");
} }
function LibViewPayslipComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵelementStart(2, "div", 27);
    i0.ɵɵelement(3, "ngx-extended-pdf-viewer", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("src", ctx_r1.pdfSrc);
} }
class LibViewPayslipComponent {
    constructor(config, LibViewPayslipService, renderer, el) {
        this.config = config;
        this.LibViewPayslipService = LibViewPayslipService;
        this.renderer = renderer;
        this.el = el;
        this.observableSubscription$ = new Subject();
        this.payload = {};
        this.getPDFResponse = [];
        this.showLoader = false;
        this.enablePdfSrc = false;
        this.getBreakupDetails = [];
        this.subscription = [];
    }
    ngOnInit() {
        const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO'));
        this.pageFormDetails = Object.assign({}, ...fbFormDataDTO);
        this.getPDF();
    }
    getPDF() {
        if (this.config.data) {
            this.enablePdfSrc = false;
            this.getBreakupDetails.push(this.config.data.data);
        }
        else {
            this.enablePdfSrc = true;
            if (this.pageFormDetails) {
                this.payload = {
                    employeeId: this.pageFormDetails.employeeId,
                    startDate: this.pageFormDetails["161"],
                    endDate: this.pageFormDetails["162"]
                };
                this.LibViewPayslipService.getPayslipDownloadDetails(this.payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    if (response.data) {
                        const path = environment.docs + response.data.replace('/var/imagility/uploads/', '');
                        this.pdfSrc = path;
                    }
                    //this.subscribeToPrintEvent();
                });
            }
        }
    }
    /*  subscribeToPrintEvent() {
       const pdfPrintButton = this.el.nativeElement.querySelector('pdf-print button');
       if (pdfPrintButton) {
         this.renderer.listen(pdfPrintButton, 'click', () => {
           this.setPrintContainerStyle();
         });
       }
     } */
    /*  setPrintContainerStyle() {
       const printContainerDiv = document.querySelector('#printContainer>div');
       if (printContainerDiv) {
         this.renderer.setStyle(printContainerDiv, 'display', 'inline');
       } else {
         setTimeout(() => {
           this.setPrintContainerStyle();
         }, 50);
       }
     } */
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.subscription.forEach(sub => sub.unsubscribe());
    }
}
LibViewPayslipComponent.ɵfac = function LibViewPayslipComponent_Factory(t) { return new (t || LibViewPayslipComponent)(i0.ɵɵdirectiveInject(i1$1.DynamicDialogConfig), i0.ɵɵdirectiveInject(LibViewPayslipService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef)); };
LibViewPayslipComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibViewPayslipComponent, selectors: [["lib-view-payslip"]], decls: 2, vars: 2, consts: [["class", "row", 4, "ngIf"], [1, "row"], [1, "payslip_content_container", "col-12"], [1, "address_section", "row"], [1, "col-2", "img_position"], ["src", "", "alt", "company-logo"], [1, "col-8", "text-center"], [1, "w-600"], [1, "employee_info_section", "row"], [1, "col-12", "text-center", "p-0"], [1, "p-1", "w-600"], [1, "col-6"], [1, "payslip_table", 3, "value", "responsive"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "footer"], [1, "employer_info_section", "row"], [1, "col-6", "text-left"], [1, "col-6", "text-right"], [1, "col-12", "footer_compay_name", "text-center"], ["colspan", "2"], [1, "pr-2"], [1, "pb-0"], ["colspan", "3", 1, "text-left", "pb-0"], [1, "pt-0"], ["colspan", "3", 1, "text-left", "pt-0"], [1, "col-12"], [1, "pdf-container"], ["height", "80vh", "useBrowserLocale", "true", 1, "letter-pdf", 2, "width", "100%", 3, "src"]], template: function LibViewPayslipComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LibViewPayslipComponent_div_0_Template, 95, 17, "div", 0);
        i0.ɵɵtemplate(1, LibViewPayslipComponent_div_1_Template, 4, 1, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.enablePdfSrc);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.enablePdfSrc);
    } }, directives: [i3.NgIf, i4.Table, i5.PrimeTemplate, i6.NgxExtendedPdfViewerComponent], pipes: [NumberToWordsPipe], styles: [".payslip_dialog_container[_ngcontent-%COMP%]{padding:0 10px}.payslip_content_container[_ngcontent-%COMP%]{border:1px solid #333;outline:8px solid #e36d05;padding:0;margin:20px 0}.payslip_content_container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:80px;width:80px}.payslip_content_container[_ngcontent-%COMP%]   .img_position[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}.payslip_content_container[_ngcontent-%COMP%]   address[_ngcontent-%COMP%]{width:60%;margin:0 auto}.payslip_content_container[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{color:#ef080d}.payslip_content_container[_ngcontent-%COMP%]   .address_section[_ngcontent-%COMP%]{border-bottom:1px solid #333}.payslip_content_container[_ngcontent-%COMP%]   .employee_info_section[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{background:#edebdf;color:#ef080d}.payslip_content_container[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style-type:none;padding:0}.payslip_content_container[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .payslip_content_container[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block}.payslip_content_container[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{width:40%;margin:0}.payslip_content_container[_ngcontent-%COMP%]   p-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{text-align:center}.payslip_content_container[_ngcontent-%COMP%]   .footer_compay_name[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#5754d7;font-size:16px}.payslip_content_container[_ngcontent-%COMP%]   .employer_info_section[_ngcontent-%COMP%]{border-top:2px solid #333;padding-top:10px;background:#fff}.payslip_content_container[_ngcontent-%COMP%]   .employer_info_section[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:12px;margin-bottom:5px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibViewPayslipComponent, [{
        type: Component,
        args: [{
                selector: 'lib-view-payslip',
                templateUrl: './lib-view-payslip.component.html',
                styleUrls: ['./lib-view-payslip.component.scss']
            }]
    }], function () { return [{ type: i1$1.DynamicDialogConfig }, { type: LibViewPayslipService }, { type: i0.Renderer2 }, { type: i0.ElementRef }]; }, null); })();

class LibViewPayslipModule {
}
LibViewPayslipModule.ɵfac = function LibViewPayslipModule_Factory(t) { return new (t || LibViewPayslipModule)(); };
LibViewPayslipModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibViewPayslipModule });
LibViewPayslipModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            ReactiveFormsModule,
            FormsModule,
            PrimengLibraryModule,
            NgxExtendedPdfViewerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibViewPayslipModule, { declarations: [LibViewPayslipComponent, NumberToWordsPipe], imports: [ReactiveFormsModule,
        FormsModule,
        PrimengLibraryModule,
        NgxExtendedPdfViewerModule], exports: [LibViewPayslipComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibViewPayslipModule, [{
        type: NgModule,
        args: [{
                declarations: [LibViewPayslipComponent, NumberToWordsPipe],
                imports: [
                    ReactiveFormsModule,
                    FormsModule,
                    PrimengLibraryModule,
                    NgxExtendedPdfViewerModule
                ],
                exports: [LibViewPayslipComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-view-payslip
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibViewPayslipComponent, LibViewPayslipModule, LibViewPayslipService };
//# sourceMappingURL=lib-view-payslip.js.map
